module.exports = __webpack_public_path__ + "static/media/img-26.d4e2e1fa.jpg";